import React from 'react'
import '../index.scss'
import { getWeightUnit, DIMENSION_UNIT } from '../../../../constants'
import { useTranslation } from 'react-i18next'
import checkCircle from '../../../../assets/images/check-circle-filled.svg'
import crossCircleRed from '../../../../assets/images/close-circle-filled-red.svg'

const PACKING_TYPE_LABELS = {
    DG_UN_PACKAGING: 'DG UN Packaging',
    METAL_BOXES: 'Metal boxes',
    WOODEN_BOXES: 'Wooden boxes',
    PLYWOOD_BOXES: 'Plywood boxes',
    FIBRE_BOARD: 'Fibre board',
    PLASTIC_BOX: 'Plastic box',
    NO_PACKAGING: 'No packaging',
    ACFT_ENGINE_ON_STAND: 'Acft Engine on stand',
}

const LooseInfoDisplay = ({
    weightUnit,
    dimensionUnit,
    looseInfocolumns,
    looseInfoDetails,
    isCrates,
    isSlrBooking = false
}) => {
    //for multilingual
    const [t] = useTranslation(['labels'])
    return (
        <div className={`looseInfo-card-wrapper ${isSlrBooking ? 'slr-booking' : ''}`}>
            {looseInfoDetails && looseInfoDetails.length > 0 ? (
                looseInfoDetails.map((looseInfo, looseInfoIndex) => (
                    <div className="looseInfo-card" key={looseInfoIndex}>
                        <div className="looseInfo-row">
                            <div className="looseInfo-col">
                                <div className="looseInfo-heading">{t(looseInfocolumns[0])}</div>
                                <div className="looseInfo-data">{looseInfo.numberOfPieces}</div>
                            </div>
                            <div className="looseInfo-col">
                                <div className="looseInfo-heading">
                                    {`${t(looseInfocolumns[1])}x${t(looseInfocolumns[2])}x${t(looseInfocolumns[3])}`}
                                </div>
                                <div className="looseInfo-data">
                                    {
                                        (looseInfo.length && looseInfo.width && looseInfo.height)
                                            ? `${looseInfo.length}×${looseInfo.width}×${looseInfo.height}`
                                            : (looseInfo.lengthPerPiece && looseInfo.widthPerPiece && looseInfo.heightPerpiece)
                                                ? `${looseInfo.lengthPerPiece}×${looseInfo.widthPerPiece}×${looseInfo.heightPerpiece}`
                                                : '-'
                                    }

                                </div>
                            </div>
                            {/* <div className="looseInfo-col">
                                <div className="looseInfo-heading">{t(looseInfocolumns[4])}</div>
                                <div className="looseInfo-data">{looseInfo.weight == 0 ? '-' : looseInfo.weight}</div>
                            </div> */}
                            <div className="looseInfo-col">
                                <div className="looseInfo-heading">
                                    {isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS' ? '' : t(looseInfocolumns[5])}
                                </div>
                                <div className="looseInfo-data">
                                    {isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS'
                                        ? ''
                                        : isSlrBooking
                                            ? (() => {
                                                const pieces = looseInfo.numberOfPieces || 1
                                                const totalW = looseInfo.weight || 0
                                                const perPiece = pieces > 0 ? (totalW / pieces).toFixed(2) : '--'
                                                return `${perPiece} ${getWeightUnit(weightUnit)}`
                                            })()
                                            : t('COMMON.TOTAL')
                                    }
                                </div>
                            </div>
                            <div className="looseInfo-col">
                                <div className="looseInfo-heading">
                                    {isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS' ? '' : t(looseInfocolumns[6])}
                                </div>
                                <div className="looseInfo-data" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    {isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS'
                                        ? ''
                                        : isSlrBooking
                                            ? (PACKING_TYPE_LABELS[looseInfo.packingType] || looseInfo.packingType || '--')
                                            : [
                                                (looseInfo.stackable === 'Y' || !looseInfo.stackable) ? t('COMMON.STACKABLE') : t('COMMON.NON_STACKABLE'),
                                                looseInfo.tiltable === 'Y' ? t('COMMON.TILTABLE') : t('COMMON.NON_TILTABLE')
                                            ].filter(Boolean).join(', ')
                                    }
                                </div>
                            </div>
                        </div>
                        {isSlrBooking && (() => {
                            const props = [
                                { key: 'stackable', satisfied: looseInfo.stackable === 'Y' || looseInfo.stackable === true, label: t('COMMON.STACKABLE') },
                                { key: 'tiltable', satisfied: looseInfo.tiltable === 'Y' || looseInfo.tiltable === true, label: t('COMMON.TILTABLE') },
                                { key: 'craneLiftable', satisfied: looseInfo.craneLiftable === 'Y' || looseInfo.craneLiftable === true, label: t('BOOKING.SLR_CRANE_LIFTABLE') },
                                { key: 'forkLiftable', satisfied: looseInfo.forkLiftable === 'Y' || looseInfo.forkLiftable === true, label: t('BOOKING.SLR_FORK_LIFTABLE') },
                                { key: 'fragile', satisfied: looseInfo.fragile === true || looseInfo.fragile === 'Y', label: t('BOOKING.SLR_FRAGILE') },
                            ]
                            return (
                                <div className='looseInfo-warnings-row cargo-property-list'>
                                    {props.map(p => (
                                        <div key={p.key} className='cargo-property-item'>
                                            <img
                                                src={p.satisfied ? checkCircle : crossCircleRed}
                                                className='cargo-property-icon'
                                                alt={p.satisfied ? 'yes' : 'no'}
                                            />
                                            <span className='cargo-property-label'>{p.label}</span>
                                        </div>
                                    ))}
                                </div>
                            )
                        })()}
                    </div>
                ))
            ) : (
                <div className="looseInfo-no-data">{t('NO_DATA')}</div>
            )}
        </div>
    )
}

export default LooseInfoDisplay